import Player from "./player";
import PlayerControl from "./control";
export default Player;
export { PlayerControl };